// extracted by mini-css-extract-plugin
module.exports = {"AddItem":"AddNewItemBtn_AddItem__3xMUF","AddIcon":"AddNewItemBtn_AddIcon__2O-NL","AddText":"AddNewItemBtn_AddText__eBz5I","ItemContainer":"AddNewItemBtn_ItemContainer__3e3B6"};